module.exports = __webpack_public_path__ + "media/withdrawal/de-a7781b74.pdf";